import { render } from "./AiAssistance.vue?vue&type=template&id=c46de5f2&scoped=true"
import script from "./AiAssistance.vue?vue&type=script&lang=js"
export * from "./AiAssistance.vue?vue&type=script&lang=js"

import "./AiAssistance.vue?vue&type=style&index=0&id=c46de5f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c46de5f2"]])

export default __exports__